import { useCallback } from 'react';
import { useNCTextLocalizer } from '../../../../locale/useNCTextLocalizer';
import { basicColors } from '../BasicColorPallete';
import { useHexBidiFormatter } from './useHexBidiFormatter';
export const useCustomColorPickerA11yInfo = () => {
  const localize = useNCTextLocalizer('ColorPicker');
  const hexBidiFormatter = useHexBidiFormatter();
  return useCallback((currentColor, currentColorType, newColor, newColorType) => {
    // CurrentSwatch tooltip and aria-label
    const currentSwatchTitle = !basicColors.includes(currentColor) ? hexBidiFormatter(currentColor) : `${localize(`color.${currentColor?.slice(1)}.title`)} (${hexBidiFormatter(currentColor)})`;
    const currentSwatchTooltip = currentColor === '' && currentColorType === 'nocolor' ? localize('color.noColor.title') : currentColorType === 'automatic' ? localize('automatic.title', {
      color: currentSwatchTitle
    }) : currentSwatchTitle;
    const currentSwatchAria = !basicColors.includes(currentColor) ? `${currentColor?.split('').join(' ')}` : `${localize(`color.${currentColor?.slice(1)}.aria`)} (${currentColor?.split('').join(' ')})`;
    const currentSwatchAriaLabel = currentColor === '' && currentColorType === 'nocolor' ? localize('color.noColor.aria') : currentColorType === 'automatic' ? localize('automatic.aria', {
      color: currentSwatchAria
    }) : currentSwatchAria;

    // NewSwatch tooltip and aria-label
    const newSwatchTitle = !basicColors.includes(newColor) ? hexBidiFormatter(newColor) : `${localize(`color.${newColor?.slice(1)}.title`)} (${hexBidiFormatter(newColor)})`;
    const newSwatchTooltip = newColor === '' && newColorType === 'nocolor' ? localize('color.noColor.title') : newColorType === 'automatic' ? localize('automatic.title', {
      color: newSwatchTitle
    }) : newSwatchTitle;
    const newSwatchAria = !basicColors.includes(newColor) ? `${newColor?.split('').join(' ')}` : `${localize(`color.${newColor?.slice(1)}.aria`)} (${newColor?.split('').join(' ')})`;
    const newSwatchAriaLabel = newColor === '' && newColorType === 'nocolor' ? localize('color.noColor.aria') : newColorType === 'automatic' ? localize('automatic.aria', {
      color: newSwatchAria
    }) : newSwatchAria;
    return {
      currentAriaLabel: localize('customTab.currentColorSwatch.aria', {
        color: currentSwatchAriaLabel
      }),
      currentToolTip: localize('customTab.currentColorSwatch.title', {
        color: currentSwatchTooltip
      }),
      newAriaLabel: localize('customTab.newColorSwatch.aria', {
        color: newSwatchAriaLabel
      }),
      newToolTip: localize('customTab.newColorSwatch.title', {
        color: newSwatchTooltip
      }),
      canvasThumbAriaLabel: localize('customTab.canvasThumb.aria', {
        selectedColor: newSwatchAriaLabel
      }),
      hueSliderThumbAriaLabel: localize('customTab.hueSliderThumb.aria', {
        color: newSwatchAriaLabel
      })
    };
  }, [hexBidiFormatter, localize]);
};
//# sourceMappingURL=useCustomColorPickerA11yInfo.js.map